import { sdk } from '../utils/grappa';
export async function fetchArticle(articleId, languageId) {
    const res = await sdk().ArticlePage({
        articleId,
        pageUrl: window.location.toString(),
        languageId,
    });
    return res;
}
export const SEARCH_PAGE_SIZE = 10;
export async function searchArticles({ controller, term, languageId, offset = 0, }) {
    const res = await sdk({ controller }).Search({
        pageUrl: window.location.toString(),
        languageId,
        query: {
            paging: {
                first: SEARCH_PAGE_SIZE,
                offset,
            },
            terms: term,
        },
    });
    return res;
}
//# sourceMappingURL=article.js.map